import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { usePrefersReducedMotion } from '../../music24/promote/themes/usePrefersReducedMotion';
import {
  AUTH_LOOP_POSTER_URL,
  AUTH_LOOP_VIDEO_URL,
  AUTH_STILL_SIZES,
  AUTH_STILL_SRC_SET,
  AUTH_STILL_URL,
} from '../../smartLinks/smlAuth/components/AuthCampaignVisual';
import { welcomeMessages as messages } from './welcomeMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole welcome page; each part uses its own slice of it */
import styles from './WelcomeView.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface WelcomeLoopProps {
  /** The wide strip of the member page (design: onboarding a7, `.ob-poster`). */
  wide?: boolean;
}

/**
 * LaziiBee's campaign as a muted 8 s loop: the four Neon feed posts of Forests (design: onboarding a1, `.ob-loop`).
 * The same video as the sign-up page (g1). With reduced motion it shows the poster only.
 */
const WelcomeLoopComponent: React.FC<WelcomeLoopProps> = ({ wide = false }) => {
  const intl = useIntl();
  const reducedMotion = usePrefersReducedMotion();
  const alt = intl.formatMessage(messages.loopAlt);

  return (
    <aside className={clsx(styles.loop, wide && styles.memberLoop)} aria-label={alt}>
      <div className={styles.loopBg} style={{ backgroundImage: `url(${AUTH_LOOP_POSTER_URL})` }} />
      {reducedMotion ? (
        <img
          className={styles.loopMedia}
          src={AUTH_STILL_URL}
          srcSet={AUTH_STILL_SRC_SET}
          sizes={AUTH_STILL_SIZES}
          width={1080}
          height={1350}
          alt={alt}
        />
      ) : (
        <video
          className={styles.loopMedia}
          src={AUTH_LOOP_VIDEO_URL}
          poster={AUTH_LOOP_POSTER_URL}
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          aria-label={alt}
        />
      )}
      <span className={styles.loopLabel}>{intl.formatMessage(messages.loopLabel)}</span>
      {/* design: a1 marks the kit phase as the current one. */}
      <div className={styles.loopPhase} aria-hidden="true">
        <span>{intl.formatMessage(messages.loopPhaseSong)}</span>
        <span className={styles.loopPhaseOn}>{intl.formatMessage(messages.loopPhaseKit)}</span>
        <span>{intl.formatMessage(messages.loopPhasePlan)}</span>
        <span>{intl.formatMessage(messages.loopPhaseNumbers)}</span>
      </div>
    </aside>
  );
};

export const WelcomeLoop = TypedMemo(WelcomeLoopComponent);
